import React, { useState } from "react";
import { X, Mail, Lock, User as UserIcon, Phone, Building2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthModal({ open, mode, onClose, switchMode }) {
  const { login, register } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [form, setForm] = useState({
    name: "", email: "", password: "", contact: "", company: "",
  });

  if (!open) return null;

  const onChange = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const res = mode === "login"
      ? await login(form.email, form.password)
      : await register(form);
    setBusy(false);
    if (res.ok) {
      toast.success(mode === "login" ? "Welcome back" : "Account created");
      onClose();
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="vj-modal-backdrop" data-testid="auth-modal-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="vj-modal" onMouseDown={(e) => e.stopPropagation()} data-testid="auth-modal">
        <div className="flex items-center justify-between px-7 py-5 border-b border-slate-200">
          <div>
            <div className="overline">{mode === "login" ? "Member Access" : "Create Account"}</div>
            <h3 className="font-display text-xl font-bold mt-1">
              {mode === "login" ? "Welcome back to VAJRON" : "Join VAJRON Global Tech"}
            </h3>
          </div>
          <button onClick={onClose} data-testid="auth-modal-close" className="text-slate-500 hover:text-slate-800">
            <X size={18}/>
          </button>
        </div>

        <form onSubmit={submit} className="px-7 py-6 space-y-4">
          {mode === "signup" && (
            <div>
              <label className="overline block mb-1.5">Full Name</label>
              <div className="relative">
                <UserIcon size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"/>
                <input data-testid="signup-name-input" required value={form.name} onChange={onChange("name")} className="vj-input" style={{paddingLeft: 38}} placeholder="Your full name"/>
              </div>
            </div>
          )}
          <div>
            <label className="overline block mb-1.5">Email</label>
            <div className="relative">
              <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"/>
              <input data-testid="auth-email-input" type="email" required value={form.email} onChange={onChange("email")} className="vj-input" style={{paddingLeft: 38}} placeholder="you@company.com"/>
            </div>
          </div>
          <div>
            <label className="overline block mb-1.5">Password</label>
            <div className="relative">
              <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"/>
              <input data-testid="auth-password-input" type="password" required minLength={6} value={form.password} onChange={onChange("password")} className="vj-input" style={{paddingLeft: 38}} placeholder="Minimum 6 characters"/>
            </div>
          </div>
          {mode === "signup" && (
            <>
              <div>
                <label className="overline block mb-1.5">Contact Number</label>
                <div className="relative">
                  <Phone size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"/>
                  <input data-testid="signup-contact-input" value={form.contact} onChange={onChange("contact")} className="vj-input" style={{paddingLeft: 38}} placeholder="+91 ..."/>
                </div>
              </div>
              <div>
                <label className="overline block mb-1.5">Company <span className="text-slate-400 normal-case">(optional)</span></label>
                <div className="relative">
                  <Building2 size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"/>
                  <input data-testid="signup-company-input" value={form.company} onChange={onChange("company")} className="vj-input" style={{paddingLeft: 38}} placeholder="Organization"/>
                </div>
              </div>
            </>
          )}

          {err && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 px-3 py-2" data-testid="auth-error">
              {err}
            </div>
          )}

          <button disabled={busy} type="submit" data-testid="auth-submit-btn" className="vj-btn-primary w-full">
            {busy ? "Please wait…" : mode === "login" ? "Log in" : "Create account"}
          </button>

          <div className="text-center text-sm text-slate-500">
            {mode === "login" ? (
              <>New to VAJRON? <button type="button" onClick={() => switchMode("signup")} data-testid="switch-to-signup" className="vj-link">Create an account</button></>
            ) : (
              <>Already have an account? <button type="button" onClick={() => switchMode("login")} data-testid="switch-to-login" className="vj-link">Log in</button></>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
